import base64 from 'base-64';
import { NativeModules } from 'react-native';
import utf8 from 'utf8';
import isExpoGo from './helpers/isExpoGo';
import TurboModule from './specs/NativeSherloModule';
let SherloModule;
const { SherloModule: SherloNativeModule } = NativeModules;
const module = TurboModule || SherloNativeModule;
if (module !== null) {
    SherloModule = createSherloModule();
}
else {
    SherloModule = createDummySherloModule();
    if (!isExpoGo) {
        console.warn('@sherlo/react-native-storybook: Sherlo native module is not accessible. Rebuild the app to link it on the native side.');
    }
}
export default SherloModule;
/* ========================================================================== */
function createSherloModule() {
    const getConstants = () => {
        var _a, _b;
        const turboModuleConstants = ((_a = module.getSherloConstants) === null || _a === void 0 ? void 0 : _a.call(module)) || {};
        const nativeModuleConstants = ((_b = module.getConstants) === null || _b === void 0 ? void 0 : _b.call(module)) || {};
        return { ...turboModuleConstants, ...nativeModuleConstants };
    };
    const sherloModule = {
        isTurboModule: !!TurboModule,
        getInspectorData: async () => {
            const inspectorDataString = await module.getInspectorData();
            return JSON.parse(inspectorDataString);
        },
        stabilize: async (requiredMatches, minScreenshotsCount, intervalMs, timeoutMs, saveScreenshots) => {
            return module.stabilize(requiredMatches, minScreenshotsCount, intervalMs, timeoutMs, saveScreenshots);
        },
        getMode: () => {
            return getConstants().mode;
        },
        getConfig: () => {
            const configString = getConstants().config;
            const config = JSON.parse(configString);
            if (!config) {
                throw new Error('Config is undefined');
            }
            return config;
        },
        getLastState: () => {
            const configString = getConstants().config;
            const config = JSON.parse(configString);
            if (config === null || config === void 0 ? void 0 : config.overrideLastState) {
                return config.overrideLastState;
            }
            const lastState = getConstants().lastState;
            const parsedLastState = lastState ? JSON.parse(lastState) : undefined;
            if (parsedLastState && Object.keys(parsedLastState).length === 0) {
                return undefined;
            }
            return parsedLastState;
        },
        appendFile: (filename, data) => {
            const encodedData = base64.encode(utf8.encode(data));
            return module.appendFile(filename, encodedData);
        },
        readFile: (filename) => {
            const decodeData = (data) => utf8.decode(base64.decode(data));
            return module.readFile(filename).then(decodeData);
        },
        openStorybook: () => module.openStorybook(),
        toggleStorybook: () => module.toggleStorybook(),
    };
    return sherloModule;
}
function createDummySherloModule() {
    return {
        isTurboModule: false,
        getInspectorData: async () => ({
            viewHierarchy: {
                id: 1,
                className: 'View',
                isVisible: true,
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            density: 1,
            fontScale: 1,
        }),
        // IMPORTANT: We should make sure that the mode is always 'default'
        // because if user doesn't want to supply native library in their production
        // build, this will be the value returned.
        getMode: () => 'default',
        getLastState: () => undefined,
        getConfig: () => ({
            stabilization: {
                requiredMatches: 3,
                minScreenshotsCount: 3,
                intervalMs: 500,
                timeoutMs: 5000,
                saveScreenshots: true,
            },
        }),
        appendFile: async () => { },
        readFile: async () => '',
        openStorybook: () => { },
        toggleStorybook: () => { },
        stabilize: async () => true,
    };
}
//# sourceMappingURL=SherloModule.js.map